import { useState } from "react";
import Layout from "../../layout/layout"
import LevelWiseIncome from "./lavelWiseIncome/levelWiseIncome";
import UserWiseIncome from "./userWiseIncome/userWiseIncome";

const IncomeWise = () => {
    const [activeTab, setActiveTab] = useState('Level Wise');

    return (
        <Layout>
            <div className="container">
                {/* Tabs */}
                <ul className="nav nav-tabs border-0">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'Level Wise' ? 'active' : 'text-light nav-link-hover-cus'}`}
                            onClick={() => setActiveTab('Level Wise')}
                        >
                            Level Wise
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'User Wise' ? 'active' : 'text-light nav-link-hover-cus'}`}
                            onClick={() => setActiveTab('User Wise')}
                        >
                            User Wise
                        </button>
                    </li>
                </ul>

                {/* Tab Content */}
                <div className="tab-content py-3 border-top-0">
                    {activeTab === 'Level Wise' && <LevelWiseIncome />}
                    {activeTab === 'User Wise' && <UserWiseIncome />}
                </div>
            </div>
        </Layout>
    )
}

export default IncomeWise